var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndcall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 59,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67.448,
    height: 58.333,
    rx: 29.167,
    fill: "#F8000F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.762c.028-.072.074-.142.083-.216.055-.486.283-.886.632-1.212 3.329-3.114 7.215-5.165 11.676-6.12a23.321 23.321 0 0 1 5.27-.537c5.362.085 10.215 1.703 14.507 4.935a28.62 28.62 0 0 1 2.058 1.736c.823.75.91 2.035.144 2.85a97.48 97.48 0 0 1-3.608 3.623c-.811.775-1.906.748-2.793.054a84.937 84.937 0 0 0-2.502-1.884c-.301-.219-.65-.372-.975-.556-.755-.428-1.157-1.057-1.148-1.943.012-1.204-.005-2.41.011-3.615.004-.3-.103-.412-.386-.473-2.339-.505-4.711-.56-7.083-.458-1.286.056-2.563.3-3.845.452-.334.039-.474.173-.466.541.026 1.182.005 2.365.01 3.547.004.854-.37 1.5-1.106 1.899a19.259 19.259 0 0 0-3.457 2.415c-.933.809-2.132.746-3.014-.124-1.101-1.085-2.186-2.186-3.28-3.28-.354-.355-.61-.76-.65-1.276-.005-.075-.05-.148-.077-.222L16 30.762Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndcall);
export default __webpack_public_path__ + "static/media/endcall.eb0af8645e4cf24a2cea4e9a4b1aacca.svg";
export { ForwardRef as ReactComponent };